import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state to display the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to an error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Render a fallback UI
            return (
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Something went wrong. Please try again later.
                </Alert>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
